import React, { useState, useEffect } from 'react';
import { tasksApi } from '../../api/tasks';
import WidgetCard from './WidgetCard';
import WidgetModal from './WidgetModal';
import TaskPanel from '../tasks/TaskPanel';
import CreateTaskModal from '../tasks/CreateTaskModal';
import { adminApi } from '../../api/admin';

export default function TaskPreviewWidget({ recordId, recordTypeId, record , onJumpToTab, tabs}) {
  const [summary, setSummary] = useState(null);
  const [createOpen, setCreateOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [stages, setStages] = useState([]);
  const [allTasks, setAllTasks] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const fetchSummary = () => {
    tasksApi.getForRecord(recordId).then(r => {
      const data = r.data || r;
      const all = [];
      Object.values(data.grouped || {}).forEach(arr => all.push(...arr));
      const open = all.filter(t => t.status !== 'completed' && t.status !== 'cancelled');
      const overdue = open.filter(t => t.due_date && new Date(t.due_date) < new Date());
      setAllTasks(all);
      setSummary({ total: all.length, open: open.length, overdue: overdue.length, completed: all.filter(t=>t.status==='completed').length, recent: open });
    }).catch(() => {});
  };
  useEffect(() => { fetchSummary(); }, [recordId]);
  useEffect(() => {
    adminApi.getUsers().then(res => setUsers(res.data.users || [])).catch(() => {});
    if (record?.workflow_id) {
      adminApi.getWorkflowStages(record.workflow_id).then(res => setStages(res.data.stages || [])).catch(() => {});
    }
  }, [record?.workflow_id]);

  const PRIO = { urgent:'bg-red-100 text-red-700', high:'bg-orange-100 text-orange-700', normal:'bg-blue-100 text-blue-700', low:'bg-gray-100 text-gray-600' };

  return (
    <>
      <WidgetCard title="Tasks" icon="✅" count={summary?.open} onExpand={() => setModalOpen(true)}
        headerAction={<button onClick={(e) => { e.stopPropagation(); setCreateOpen(true); }} className="text-gray-400 hover:text-brand-600 p-0.5" title="Create task"><svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M12 5v14m-7-7h14"/></svg></button>}>
        {!summary ? <p className="text-xs text-gray-400 p-4">Loading...</p> : (
          <div className="p-3">
            <div className="flex items-center gap-3 mb-2">
              <div className="flex-1 bg-gray-200 rounded-full h-1.5">
                <div className="bg-brand-500 h-1.5 rounded-full" style={{ width: summary.total ? (summary.completed/summary.total*100)+'%' : '0%' }} />
              </div>
              <span className="text-[10px] text-gray-500">{summary.completed}/{summary.total}</span>
            </div>
            {summary.overdue > 0 && <p className="text-[10px] text-red-600 font-medium mb-2">⚠ {summary.overdue} overdue</p>}
            
            {summary.recent.map(t => (
              <div key={t.id} className="flex items-center gap-2 py-1.5 text-xs">
                <div className="h-3 w-3 rounded-full border-2 border-gray-300 flex-shrink-0" />
                <span className="flex-1 truncate text-gray-700">{t.title}</span>
                <span className={`text-[10px] px-1 py-0.5 rounded ${PRIO[t.priority]||''}`}>{t.priority}</span>
              </div>
            ))}
          </div>
        )}
      </WidgetCard>
      <WidgetModal open={modalOpen} onClose={() => { setModalOpen(false); fetchSummary(); }} title="Tasks" icon="✅" width="max-w-2xl">
        <TaskPanel recordId={recordId} recordTypeId={recordTypeId} record={record}  onJumpToTab={onJumpToTab} tabs={tabs} />
      </WidgetModal>
      {createOpen && (
        <CreateTaskModal
          recordId={recordId} record={record} tasks={allTasks}
          users={users} stages={stages}
          onClose={() => setCreateOpen(false)}
          onCreated={() => { setCreateOpen(false); fetchSummary(); }} />
      )}
    </>
  );
}
